
interface CheckoutProps {
  url: string
  onSuccess: (data: any, err: any) => void
}


export const usePaddle = () => {
  // @ts-ignore
  const Paddle = window.Paddle

  const openCheckout = (props: CheckoutProps) => {
    // @ts-ignore
    Paddle.Checkout.open({
      // @ts-ignore
      override: props.url,
      successCallback: props.onSuccess
    })
  }

  return { openCheckout }
}

export default usePaddle